import script from "./StandardStock.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardStock.vue?vue&type=script&setup=true&lang=js"

import "./StandardStock.vue?vue&type=style&index=0&id=57f172b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57f172b2"]])

export default __exports__